<template>
  <div>
    <TopAppBarDrawer></TopAppBarDrawer>
    <main class="main-wrapper flex-grow-1">
      <div class="d-flex align-items-center bg-white fix-header-title">
        <div class="t-headline13 t-color-headlineBlack pda-14 t-center  flex-grow-1 ">
          <div class="font-m">{{ this.$t('3590') }}</div>
        </div>
      </div>
      <div class="divider"></div>

      <div class="pda-16 container container--narrow">
        <div class="t-headline9">
          {{ loginType === "SOCIAL" ? $t("3645") : $t("3637") }}
        </div>
        <div class="t-body3 mgt-6 t-color-bodyGrayA">
          {{ loginType === "SOCIAL" ? $t("3646") : $t("3638") }}
        </div>

        <!-- SOCIAL일 경우 -->
        <div v-if="loginType === 'SOCIAL'" class="mgt-50">
          <div
            class="d-flex align-items-center justify-content-center flex-column"
          >
            <button
              v-if="socialType.name === 'GOOGLE'"
              class="mdc-button btn-sns-sign point-mark social-button bg-google"
              @click.prevent="socialLoginAuth('google')"
              @keypress.prevent="socialLoginAuth('google')"
            >
              <img alt="google" src="/images/google.svg" />
              <span class="pdl-12 t-body1 t-color-white t-capitalize">{{
                $t("3463")
              }}</span>
            </button>
            <button
              v-if="socialType.name === 'FACEBOOK'"
              class="mdc-button btn-sns-sign point-mark facebook social-button"
              @click.prevent="socialLoginAuth('facebook')"
              @keypress.prevent="socialLoginAuth('facebook')"
            >
              <img alt="facebook" src="/images/facebook.svg" />
              <span class="pdl-12 t-body1 t-color-white t-capitalize">{{
                $t("3464")
              }}</span>
            </button>
            <div
              v-if="socialType.name === 'TELEGRAM'"
              class="mdc-button btn-sns-sign point-mark telegram social-button"
            >
              <vue-telegram-login
                :telegram-login="bot"
                mode="callback"
                size="large"
                @callback="telegramCallback"
              />
            </div>
            <button
              v-if="socialType.name === 'NAVER'"
              class="mdc-button btn-sns-sign point-mark social-button bg-naver"
              @click.prevent="socialLoginAuth('naver')"
              @keypress.prevent="socialLoginAuth('naver')"
            >
              <img alt="naver" src="/images/naver.svg" />
              <span class="pdl-12 t-body1 t-color-white t-capitalize">{{
                $t("3465")
              }}</span>
            </button>
            <button
              v-if="socialType.name === 'APPLE'"
              class="mdc-button btn-sns-sign social-button bg-apple t-capitalize"
              @click.prevent="socialLoginAuth('apple')"
              @keypress.prevent="socialLoginAuth('apple')"
            >
              <img alt="apple" src="/images/apple.svg" />
              <span class="pdl-12 t-body1 t-color-white">{{ $t("3466") }}</span>
            </button>
          </div>

          <div
            v-if="socialType.name === 'NAVER'"
            id="naver_id_login"
            ref="naverRef"
            class="naver-wrapper social-button bg-naver mgb-4 mgt-4"
          ></div>
        </div>

        <!-- PASSWORD일 경우 -->
        <div v-if="loginType === 'PASSWORD'">
          <form @submit.prevent="next()" novalidate>
            <div class="mgt-40 mgb-28">
              <label
                class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full h-46"
                data-mdc-auto-init="MDCTextField"
                :class="
                  submitState && passwordInvalidCheck
                    ? 'mdc-text-field--invalid invalid-icon-data'
                    : 'valid-icon-data'
                "
                id="passwordEl"
              >
                <span class="mdc-notched-outline">
                  <span
                    class="mdc-notched-outline__leading"
                    :style="
                      submitState && passwordInvalidCheck
                        ? 'border-color:var(--Textfeilderror)!important;'
                        : ''
                    "
                  ></span>
                  <span
                    class="mdc-notched-outline__notch"
                    :style="
                      submitState && passwordInvalidCheck
                        ? 'border-color:var(--Textfeilderror)!important;'
                        : ''
                    "
                  >
                    <span class="mdc-floating-label" id="password-message">{{
                      $t("3642")
                    }}</span>
                  </span>
                  <span
                    class="mdc-notched-outline__trailing"
                    :style="
                      submitState && passwordInvalidCheck
                        ? 'border-color:var(--Textfeilderror)!important;'
                        : ''
                    "
                  ></span>
                </span>
                <input
                  class="mdc-text-field__input"
                  type="password"
                  aria-labelledby="password-message"
                  :value="password"
                  @input="handlePassword"
                  v-validate="'required|min:8'"
                  ref="password"
                  id="password"
                  name="password"
                />
                <i
                  class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing d-block"
                  role="button"
                  :class="validIcon === 'check' ? 'check_show' : ''"
                  >{{ validIcon }}</i
                >
              </label>
              <div class="mdc-text-field-helper-line d-block">
                <div
                  :class="
                    submitState && passwordInvalidCheck ? 't-color-mainBtn' : ''
                  "
                  class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r"
                >
                  <!-- {{ $t("3644") }} -->
                  {{ password.length === 0 ? $t("3643") : $t("3644") }}
                </div>
              </div>
            </div>

            <!-- Buttons -->
            <div class="mgt-50">
              <button
                class="mdc-button mdc-button--raised btn-red mr8 bg-mainBtn"
                @click="next"
                @keypress="next"
              >
                {{ $t("3640") }}
              </button>
              <button
                class="mdc-button btn-white t-color-secondaryBtnText"
                @click="handleClose()"
                @keypress="handleClose()"
                type="button"
                tabindex="0"
              >
                {{ $t("3641") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  </div>
</template>
  
<script>
import firebase from "firebase";
import { vueTelegramLogin } from "vue-telegram-login";
import { MDCTextField } from "@material/textfield";
import { MDCRipple } from "@material/ripple";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import { topAppBarMixin } from "@/mixins/topAppBar";
import { joinMixin } from "@/mixins/join";
import memberApi from "@/api/memberApi";
import joinApi from "@/api/joinApi";
import loginApi from "@/api/loginApi";

export default {
  name: "WithdrawConfirm",

  components: {
    TopAppBarDrawer,
    vueTelegramLogin,
  },

  mixins: [topAppBarMixin, joinMixin],

  data() {
    return {
      password: "",
      passwordTextField: null,
      submitState: false,
      validIcon: "",
      loginType: "SOCIAL",
      socialType: {
        name: "TELEGRAM",
      },
      wrongPassword: false,
      socialToken: "",
      socialFirstName: "",
      socialLastName: "",
      socialFullName: "",
      socialEmail: "",
      bot: localStorage.getItem("TELEGRAM_BOT"),
    };
  },

  computed: {
    // password 유효성 Check 및 아이콘
    passwordInvalidCheck() {
      let returnValue = false;
      if (this.submitState) {
        if (this.errors.has("password")) {
          returnValue = true;
          this.validIcon = "warning";
        } else {
          returnValue = false;
          this.validIcon = "check";
        }
      }
      this.passwordTextField.valid === !returnValue
        ? ""
        : (this.passwordTextField.valid = !returnValue);
      return returnValue;
    },
  },

  mounted() {
    setTimeout(() => {
      this.setMaterialUi();
    }, [100]);
    this.loginType = this.$route.query.type;
    if (this.$route.query && this.$route.query.socialTypeName) {
      this.socialType = {
        name: this.$route.query.socialTypeName,
        id: this.$route.query.socialTypeId,
      };
    }
  },

  methods: {
    setMaterialUi() {
      const passwordEl = document.querySelector("#passwordEl");
      const mdcButtonClass = document.querySelectorAll(".mdc-button");
      if (passwordEl) {
        this.passwordTextField = new MDCTextField(passwordEl);
        this.passwordTextField.useNativeValidation = false;
        const buttonRipple = [].map.call(mdcButtonClass, function (el) {
          let button = new MDCRipple.attachTo(el);
          return button;
        });
        this.passwordTextField.value = this.password;
      }
    },

    handlePassword(e) {
      this.password = e.target.value;
    },

    handleClose() {
      this.$router.replace({
        name: "MyInformation",
      });
    },

    // 네이버 로그인 버튼 클릭
    loginNaver() {
      const fullPath = location.protocol + "//" + location.host;

      const naver_id_login = new window.naver_id_login(
        localStorage.getItem("NAVER_KEY"),
        `${fullPath}/member/withdraw-reason`
      );
      const state = naver_id_login.getUniqState();

      naver_id_login.setState(state);
      naver_id_login.setButton("", " ", 45);
      naver_id_login.init_naver_id_login();
      naver_id_login.get_naver_userprofile();
      naver_id_login.getAccessToken();

      document.getElementById("naver_id_login_anchor").click();
    },

    // 텔레그램
    async telegramCallback(user) {
      this.$showLoading();

      this.socialFirstName = user.first_name;
      this.socialLastName = "";
      this.socialFullName = user.first_name;
      this.socialEmail = user.id;

      let params = {
        uid: user.id,
        name: "telegram",
        type: "telegram",
        email: "",
      };

      // get custom token
      joinApi
        .customToken(params)
        .then((response) => {
          firebase
            .auth()
            .signInWithCustomToken(response.data.data)
            .then((result) => {
              firebase
                .auth()
                .currentUser.getIdToken()
                .then((idToken) => {
                  this.$hideLoading();

                  this.socialToken = idToken;
                  this.socialType = "telegram";
                  this.socialLoginAuth("telegram");
                })
                .catch((error) => {
                  console.log("GET ID TOKEN ERROR : ", error);
                });
            })
            .catch((error) => {
              console.log("SIGN IN WITH CUSTOM TOKEN ERROR : ", error);
            });
        })
        .catch((error) => {
          console.log("CUSTOM TOKEN ERROR : ", error);
        });
    },

    // 이메일 로그인일 경우 비밀번호 검증 함수
    next() {
      this.submitState = true;

      memberApi
        .checkPassword({ password: this.password })
        .then((res) => {
          if (res.data.data) {
            this.$router.push({
              name: "WithdrawalReason",
            });
          } else {
            this.validIcon = "warning";
            this.passwordTextField.valid = true;
            this.submitState = true;
            this.wrongPassword = true;
          }
        })
        .catch(() => {
          this.focusFirstInvalidElement();
        });
    },

    // 소셜 로그인인 경우 검증 함수
    async socialLoginAuth(socialType) {
      this.$showLoading();
      let provider = null;
      this.socialType = socialType;

      if (socialType === "google") {
        provider = new firebase.auth.GoogleAuthProvider();
      } else if (socialType === "facebook") {
        provider = new firebase.auth.FacebookAuthProvider();
      } else if (socialType === "apple") {
        provider = new firebase.auth.OAuthProvider("apple.com");
        provider.addScope("email");
        provider.addScope("name");
      } else if (socialType === "naver") {
        this.loginNaver();
      }
      
      try {
        if (socialType !== "telegram" && socialType !== "naver") {
          const firebaseAuthResult = await firebase
            .auth()
            .signInWithPopup(provider);
          if (firebaseAuthResult) {
            const firebaseAuthTokenResult = await firebase
              .auth()
              .currentUser.getIdToken(true);
            this.socialToken = firebaseAuthTokenResult;
          }
        }

        const loginResult = await loginApi.authCheck();
        if (loginResult) {
          this.$router.push({
            name: "WithdrawalReason",
          });
        } else {
          this.$alert({
            title: this.$t("3647"),
            content: this.$t("3648"),
            accept: this.$t("3649"),
          });
        }
      } catch (error) {
        console.log("FireBase Auth Error : ", error);
        //Account exists with different credential
        this.$alert({
          title: this.$t("3647"),
          content: this.$t("3648"),
          accept: this.$t("3649"),
        }).then(() => {
          window.location.reload();
        });

        if (
          error.email &&
          error.credential &&
          error.code === "auth/account-exists-with-different-credential"
        ) {
          let params = {
            title: "",
            content: error.message,
            accept: this.$t("833"),
          };
          this.$confirm(params)
            .then(() => {
              firebase.auth().signOut();
            })
            .catch(() => {
              firebase.auth().signOut();
            });
        }
      } finally {
        this.$hideLoading();
      }
    },
  },
};
</script>
  
<style scoped>
.warning {
  color: #fc5356 !important;
}

#naver_id_login {
  opacity: 0;
}
</style>